import {
  GET_FACILITY,
  GET_FACILITY_SUCCESS,
  GET_FACILITY_ERROR,
  ADD_FACILITY,
  ADD_FACILITY_SUCCESS,
  ADD_FACILITY_ERROR,
  EDIT_FACILITY,
  EDIT_FACILITY_SUCCESS,
  EDIT_FACILITY_ERROR,
  DELETE_FACILITY,
  DELETE_FACILITY_SUCCESS,
  DELETE_FACILITY_ERROR,
  ADD_FLOOR,
  ADD_FLOOR_SUCCESS,
  ADD_FLOOR_ERROR,
  EDIT_FLOOR,
  EDIT_FLOOR_SUCCESS,
  EDIT_FLOOR_ERROR,
  DELETE_FLOOR,
  DELETE_FLOOR_SUCCESS,
  DELETE_FLOOR_ERROR,
  ADD_SECTOR,
  ADD_SECTOR_SUCCESS,
  ADD_SECTOR_ERROR,
  EDIT_SECTOR,
  EDIT_SECTOR_SUCCESS,
  EDIT_SECTOR_ERROR,
  DELETE_SECTOR,
  DELETE_SECTOR_SUCCESS,
  DELETE_SECTOR_ERROR,
  ADD_SHIFT,
  ADD_SHIFT_SUCCESS,
  ADD_SHIFT_ERROR,
  EDIT_SHIFT,
  EDIT_SHIFT_SUCCESS,
  EDIT_SHIFT_ERROR,
  DELETE_SHIFT,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_ERROR,
  ADD_EMPLOYEE_POLICY,
  ADD_EMPLOYEE_POLICY_SUCCESS,
  ADD_EMPLOYEE_POLICY_ERROR,
  EDIT_EMPLOYEE_POLICY,
  EDIT_EMPLOYEE_POLICY_SUCCESS,
  EDIT_EMPLOYEE_POLICY_ERROR,
  DELETE_EMPLOYEE_POLICY,
  DELETE_EMPLOYEE_POLICY_SUCCESS,
  DELETE_EMPLOYEE_POLICY_ERROR,
  ADD_HOLIDAY,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_ERROR,
  EDIT_HOLIDAY,
  EDIT_HOLIDAY_SUCCESS,
  EDIT_HOLIDAY_ERROR,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_ERROR,
  ADD_REPORT_ALERT,
  ADD_REPORT_ALERT_SUCCESS,
  ADD_REPORT_ALERT_ERROR,
  EDIT_REPORT_ALERT,
  EDIT_REPORT_ALERT_SUCCESS,
  EDIT_REPORT_ALERT_ERROR,
  DELETE_REPORT_ALERT,
  DELETE_REPORT_ALERT_SUCCESS,
  DELETE_REPORT_ALERT_ERROR,
  ADD_COMPLIANCE_ALERT,
  ADD_FACILITY_ALERT,
} from "./actions";
import { omit } from "lodash";

const INIT_STATE = {
  company: {},
  facility: {},
  floor: {},
  sector: {},
  shift: {},
  employee_policy: {},
  holiday_list: {},
  compliance_alerts: [],
  facility_alerts: [],
  report_alerts: {},
  error: "",
  loading: false,
  initial_load: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_FACILITY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_FACILITY_SUCCESS:
      return {
        ...state,
        facility: {
          ...state.facility,
          [action.payload.id]: action.payload,
        },
        loading: false,
        error: "",
      };
    case ADD_FACILITY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_FACILITY:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_FACILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        initial_load: true,
        facility: action.payload.facilities,
        floor: action.payload.floors,
        sector: action.payload.sectors,
        company: action.payload.companies,
        shift: action.payload.shifts,
        employee_policy: action.payload.employee_policies,
        holiday_list: action.payload.holiday_list,
        report_alerts: action.payload.report_alerts,
      };
    case GET_FACILITY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_FACILITY:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case EDIT_FACILITY_SUCCESS:
      console.log("started reducing");
      return {
        ...state,
        loading: false,
        error: "",
        facility: {
          ...state.facility,
          [action.payload.id]: action.payload,
        },
      };
    case EDIT_FACILITY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_FACILITY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_FACILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        facility: omit(state.facility, action.payload),
      };
    case DELETE_FACILITY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case ADD_FLOOR:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        floor: { ...state.floor, [action.payload.id]: action.payload },
      };
    case ADD_FLOOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_FLOOR:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        floor: { ...state.floor, [action.payload.id]: action.payload },
      };
    case EDIT_FLOOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_FLOOR:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_FLOOR_SUCCESS:
      return {
        ...state,
        loading: false,
        floor: omit(state.floor, action.payload),
      };
    case DELETE_FLOOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case ADD_SECTOR:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SECTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        sector: { ...state.sector, [action.payload.id]: action.payload },
      };
    case ADD_SECTOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_SECTOR:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_SECTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        sector: { ...state.sector, [action.payload.id]: action.payload },
      };
    case EDIT_SECTOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_SECTOR:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SECTOR_SUCCESS:
      console.log(action.payload);
      console.log(omit(state.sector, [action.payload]));
      return {
        ...state,
        loading: false,
        sector: omit(state.sector, action.payload),
      };
    case DELETE_SECTOR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case ADD_SHIFT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        shift: { ...state.shift, [action.payload.id]: action.payload },
      };
    case ADD_SHIFT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_SHIFT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_SHIFT_SUCCESS:
      return {
        ...state,
        loading: false,
        shift: { ...state.shift, [action.payload.id]: action.payload },
      };
    case EDIT_SHIFT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_SHIFT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SHIFT_SUCCESS:
      console.log(action.payload);
      console.log(omit(state.shift, [action.payload]));
      return {
        ...state,
        loading: false,
        shift: omit(state.shift, action.payload),
      };
    case DELETE_SHIFT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case ADD_EMPLOYEE_POLICY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_EMPLOYEE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        employee_policy: {
          ...state.employee_policy,
          [action.payload.id]: action.payload,
        },
      };
    case ADD_EMPLOYEE_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_EMPLOYEE_POLICY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_EMPLOYEE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        employee_policy: {
          ...state.employee_policy,
          [action.payload.id]: action.payload,
        },
      };
    case EDIT_EMPLOYEE_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_EMPLOYEE_POLICY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_EMPLOYEE_POLICY_SUCCESS:
      console.log(action.payload);
      console.log(omit(state.employee_policy, [action.payload]));
      return {
        ...state,
        loading: false,
        employee_policy: omit(state.employee_policy, action.payload),
      };
    case DELETE_EMPLOYEE_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case ADD_HOLIDAY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        holiday_list: {
          ...state.holiday_list,
          [action.payload.id]: action.payload,
        },
      };
    case ADD_HOLIDAY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_HOLIDAY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        holiday_list: {
          ...state.holiday_list,
          [action.payload.id]: action.payload,
        },
      };
    case EDIT_HOLIDAY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_HOLIDAY:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_HOLIDAY_SUCCESS:
      console.log(action.payload);
      console.log(omit(state.holiday_list, [action.payload]));
      return {
        ...state,
        loading: false,
        holiday_list: omit(state.holiday_list, action.payload),
      };
    case DELETE_HOLIDAY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case ADD_REPORT_ALERT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_REPORT_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
        report_alerts: {
          ...state.report_alerts,
          [action.payload.id]: action.payload,
        },
      };
    case ADD_REPORT_ALERT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case EDIT_REPORT_ALERT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case EDIT_REPORT_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
        report_alerts: {
          ...state.report_alerts,
          [action.payload.id]: action.payload,
        },
      };
    case EDIT_REPORT_ALERT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case DELETE_REPORT_ALERT:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_REPORT_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
        holiday_list: omit(state.report_alerts, action.payload),
      };
    case DELETE_REPORT_ALERT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };

    case ADD_COMPLIANCE_ALERT:
      return {
        ...state,
        loading: false,
        compliance_alerts: state.compliance_alerts.concat(action.payload),
      };

    case ADD_FACILITY_ALERT:
      return {
        ...state,
        loading: false,
        facility_alerts: state.facility_alerts.concat(action.payload),
      };

    default:
      return {
        ...state,
      };
  }
};
